export default class RateSheet {
  constructor (rateSheetId, name, rateSheetLines = [], effectiveDate = null, expirationDate = null, rateSheetDefinitionId = null) {
    this.rateSheetId = rateSheetId
    this.name = name
    this.rateSheetLines = rateSheetLines
    this.effectiveDate = effectiveDate
    this.expirationDate = expirationDate
    this.rateSheetDefinitionId = rateSheetDefinitionId
  }

  static fromServerResponse (serverRateSheet) {
    return new RateSheet(
      serverRateSheet.rateSheetId,
      serverRateSheet.name,
      serverRateSheet.rateSheetLines,
      serverRateSheet.effectiveDate,
      serverRateSheet.expirationDate,
      serverRateSheet.rateSheetDefinitionId
    )
  }

  static fromDefinition ({ name, rateSheetId }) {
    return new RateSheet(rateSheetId, name)
  }
}
